import { type FC, useMemo } from 'react'
import { useZocksQuota } from '../../../../../../../components/ScopedBlock/hooks'
import { DefaultResultCardHeaderButtons, type ResultCardHeaderButtonsProps } from '../../ResultCard/Header/ResultCardHeaderButtons'

export const FutureMeetingsHeaderButtons: FC<ResultCardHeaderButtonsProps> = (props) => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota({ refetchQuota: false, pollingInterval: 0 })
  const { headerResultOptionsConfig } = props

  const configWithoutEdit = useMemo(
    () => ({ ...headerResultOptionsConfig, hiddenOptions: [...(headerResultOptionsConfig?.hiddenOptions ?? []), 'edit'] }),
    [headerResultOptionsConfig],
  )

  if (!quotaSuccess && isFetching) {
    return null
  }

  return (
    <DefaultResultCardHeaderButtons
      {...props}
      headerResultOptionsConfig={hasQuota('scheduling.enabled.value') ? configWithoutEdit : headerResultOptionsConfig}
    />
  )
}
